import { Box, Stack } from '@mui/material'
import { Button, Container, Typography } from '@evocolabs/orkaui'

import Calendly from '@/src/components/Calendly'
import Call40 from '@evocolabs/icons/lib/Call40'
import Link from 'next/link'
import { getEnvVar } from '@/env'
import { useState } from 'react'
import styles from './styles.module.scss'

const text = {
  title: 'Not sure if Orka Two is right for you?',
  blogTitle: 'Learn More About Orka',
  contactTitle: 'Get on a call with a Product Specialist',
  phone: '(800) 653-6022',
  workingHours: 'Working Hours: 9 AM - 6 PM CT Mon-Fri',
  scheduleTitle: 'Or schedule a time that works better for you',
  scheduleCTA: 'Schedule Now'
}

const link = {
  phone: 'tel:(800) 653-6022',
  schedule: getEnvVar('NEXT_PUBLIC_SCHEDULE_PHONE_CALL_URL')
}

const SchedulePhoneCall = ({
  asBlogCard = false
}: {
  asBlogCard?: boolean
}) => {
  const {
    title,
    blogTitle,
    contactTitle,
    phone,
    workingHours,
    scheduleTitle,
    scheduleCTA
  } = text

  const [open, setOpen] = useState(false)

  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return link.schedule !== 'undefined' ? (
    <Container
      className={
        asBlogCard
          ? styles['schedule-phone-call-blog-card']
          : styles['schedule-phone-call']
      }
    >
      <Typography variant="h2" textAlign="center">
        {asBlogCard ? blogTitle : title}
      </Typography>
      <Box className={styles['content-container']}>
        <Stack className={styles.content}>
          <Typography variant="body1" textAlign="center">
            {contactTitle}
          </Typography>
          <Box mt={{ xs: 2, dl: 4 }} display="flex" gap={1} alignItems="center">
            <Call40 replaceColor={[['#30445E', 'black']]} />
            <Link href={link.phone}>
              <Typography variant="h4" textAlign="center">
                {phone}
              </Typography>
            </Link>
          </Box>
          <Typography variant="body3" textAlign="center">
            {workingHours}
          </Typography>
        </Stack>
        <Stack className={styles.content}>
          <Typography variant="body1" textAlign="center">
            {scheduleTitle}
          </Typography>
          <Button
            id="product-page-schedule-now-button"
            sx={{ mt: { xs: 2, dl: 5 } }}
            onClick={handleOpen}
          >
            {scheduleCTA}
          </Button>
        </Stack>
      </Box>
      <Calendly open={open} onClose={handleClose} />
    </Container>
  ) : null
}

export default SchedulePhoneCall
